import React from 'react';
import { BearingClass, TimkenUnit } from '../../components/bearing-search/types/types';
import { handleActionError } from '../utils/engineering-tools';

export type FittingPracticeState = {
	unit: TimkenUnit;
	bearingClass?: BearingClass;
};

export const initialFittingPracticeState: FittingPracticeState = {
	unit: 'M',
};

export type FittingPracticeAction =
	| { type: 'change_unit'; payload: TimkenUnit }
	| { type: 'change_bearing_class'; payload?: BearingClass }
	| { type: 'reset'; payload?: FittingPracticeState };

const fittingPracticeReducer: React.Reducer<
	FittingPracticeState,
	FittingPracticeAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_unit': {
			return {
				...state,
				unit: action.payload,
			};
		}
		case 'change_bearing_class': {
			if ( ! action.payload ) {
				return {
					...state,
				};
			}

			return {
				...state,
				bearingClass: action.payload,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialFittingPracticeState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default fittingPracticeReducer;
